import api from './api';

const productoService = {
  // Obtener todos los productos
  getProductos: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.sucursal && params.sucursal !== '') {
        queryParams.append('sucursal', params.sucursal.toLowerCase());
      }
      
      const queryString = queryParams.toString();
      const url = queryString ? `/productos?${queryString}` : '/productos';
      
      const response = await api.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener producto por ID
  getProductoById: async (id) => {
    try {
      const response = await api.get(`/productos/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Crear nuevo producto
  createProducto: async (productoData) => {
    try {
      const response = await api.post('/productos', productoData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Actualizar producto
  updateProducto: async (id, productoData) => {
    try {
      const response = await api.put(`/productos/${id}`, productoData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Eliminar producto
  deleteProducto: async (id, sucursal) => {
    try {
      const response = await api.delete(`/productos/${id}`, {
        data: { sucursal }
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Obtener stock por sucursal
  getStockPorSucursal: async (sucursal) => {
    try {
      const response = await api.get(`/productos/stock/${sucursal}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Actualizar stock
  updateStock: async (id, sucursal, cantidad) => {
    try {
      const response = await api.put(`/productos/${id}/stock`, {
        sucursal,
        cantidad
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default productoService;